import {
  OFFLINE_EVENT,
  ONLINE_EVENT,
  ActionStatus,
  OfflineEventManagerActionTypes,
} from '@parapet/common';
import {
  ActionTypes,
  SET_AUTH_TOKEN,
  AUTH_USER,
  SET_AUTH_STATUS,
} from './types';

export interface UserState {
  token: string | null;
  tokenExpires: Date | null;
  cookie: string;
  authStatus: ActionStatus;
  passwordStatus: ActionStatus;
  offline: boolean;
}

const initialState: UserState = {
  /** Passed as header in each xhr */
  token: null,
  /** Time of token expiry */
  tokenExpires: null,
  /** Only for reference */
  cookie: '',
  /** Status of login or initial auth */
  authStatus: ActionStatus.default,
  /** Status of a user's request pending a force password change */
  passwordStatus: ActionStatus.default,
  /** Does the user have no connection? */
  offline: false,
};

export function userReducer(
  state = initialState,
  action: ActionTypes | OfflineEventManagerActionTypes,
): UserState {
  switch (action.type) {
    case SET_AUTH_TOKEN:
      return {
        ...state,
        token: action.token,
        tokenExpires: new Date(action.expires),
      };

    case AUTH_USER:
      return {
        ...state,
        authStatus: ActionStatus.loading,
      };

    case SET_AUTH_STATUS:
      return {
        ...state,
        authStatus: action.status,
      };

    case OFFLINE_EVENT:
      return {
        ...state,
        offline: true,
      };

    case ONLINE_EVENT:
      return {
        ...state,
        offline: false,
      };

    default:
      return state;
  }
}
